import { useTranslation } from "@hireroo/i18n";
import { styled } from "@mui/material/styles";
import TableContainer from "@mui/material/TableContainer";
import Typography from "@mui/material/Typography";
import * as React from "react";

import DivTable from "../../../primitive/DivTable/DivTable";
import DivTableBody from "../../../primitive/DivTableBody/DivTableBody";
import DivTableCell from "../../../primitive/DivTableCell/DivTableCell";
import DivTableHead from "../../../primitive/DivTableHead/DivTableHead";
import DivTableRow from "../../../primitive/DivTableRow/DivTableRow";
import QuestionOverviewTableRow, { QuestionOverviewTableRowProps } from "./parts/QuestionOverviewTableRow/QuestionOverviewTableRow";

const StyledTable = styled(DivTable)(() => ({
  height: "fit-content",
  wordBreak: "keep-all",
}));
const StyledTableCell = styled(DivTableCell)(() => ({
  border: "none",
  display: "table-cell",
  padding: "0 16px",
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  lineHeight: "266%",
  color: theme.palette.text.secondary,
}));

export type QuestionOverviewTableProps = {
  rows: QuestionOverviewTableRowProps[];
};

const QuestionOverviewTable: React.FC<QuestionOverviewTableProps> = props => {
  const { t } = useTranslation();
  return (
    <TableContainer>
      <StyledTable width="100%">
        <DivTableHead>
          <DivTableRow>
            <StyledTableCell sx={{ width: "65%" }}>
              <StyledTypography>{t("出題問題")}</StyledTypography>
            </StyledTableCell>
            <StyledTableCell sx={{ width: "10%" }}>
              <StyledTypography>{t("難易度")}</StyledTypography>
            </StyledTableCell>
            <StyledTableCell sx={{ width: "25%" }}>
              <StyledTypography>{t("言語指定・リソース種別")}</StyledTypography>
            </StyledTableCell>
          </DivTableRow>
        </DivTableHead>
        <DivTableBody>
          {props.rows.map((row, index) => (
            <QuestionOverviewTableRow key={`row-${index}`} {...row} />
          ))}
        </DivTableBody>
      </StyledTable>
    </TableContainer>
  );
};

QuestionOverviewTable.displayName = "QuestionOverviewTable";

export default QuestionOverviewTable;
